/**
 * Preserve list-page location (including ?tab=) when opening Agent Workspace tickets,
 * so browser Back and "close last tab" restore the exact prior view.
 */

const WORKSPACE_RETURN_TO_KEY = 'workspace-return-to';

export function getCurrentLocationPath(location: { pathname: string; search?: string }): string {
  return `${location.pathname}${location.search || ''}`;
}

export function setWorkspaceReturnTo(returnTo: string | null | undefined): void {
  try {
    if (!returnTo || !returnTo.startsWith('/')) {
      sessionStorage.removeItem(WORKSPACE_RETURN_TO_KEY);
      return;
    }
    sessionStorage.setItem(WORKSPACE_RETURN_TO_KEY, returnTo);
  } catch {
    // ignore storage errors
  }
}

export function getWorkspaceReturnTo(fallback = '/tickets'): string {
  try {
    const stored = sessionStorage.getItem(WORKSPACE_RETURN_TO_KEY);
    if (stored && stored.startsWith('/')) return stored;
  } catch {
    // ignore storage errors
  }
  return fallback;
}

export function buildWorkspaceNavigationState(
  location: { pathname: string; search?: string; state?: unknown },
  extras: Record<string, unknown> = {}
): Record<string, unknown> {
  const existingState =
    location.state && typeof location.state === 'object'
      ? (location.state as Record<string, unknown>)
      : {};
  const returnTo =
    (typeof existingState.returnTo === 'string' && existingState.returnTo.startsWith('/')
      ? existingState.returnTo
      : null)
    || (location.pathname.startsWith('/workspace')
      ? getWorkspaceReturnTo(getCurrentLocationPath(location))
      : getCurrentLocationPath(location));

  setWorkspaceReturnTo(returnTo);

  return {
    ...extras,
    returnTo,
  };
}

export function workspaceTicketPath(ticketNumber: string | number): string {
  return `/workspace/number/${ticketNumber}`;
}
